import { render, staticRenderFns } from "./PrizeItemConfig.vue?vue&type=template&id=1e070656&scoped=true"
import script from "./PrizeItemConfig.vue?vue&type=script&lang=js"
export * from "./PrizeItemConfig.vue?vue&type=script&lang=js"
import style0 from "./PrizeItemConfig.vue?vue&type=style&index=0&id=1e070656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e070656",
  null
  
)

export default component.exports